import React from 'react';
import PropTypes from 'prop-types';
import { DropDown, ErrorMessage } from 'anf-core-react';

export default function HelpReasonDropDown({
  id,
  isInvalid,
  onChange,
  value,
  text,
}) {
  const { label, options, error } = text;

  const processOptions = (option) => ({ label: option.text?.value, value: option.optionValue });

  return (
    <div className="help-reason-dropdown">
      <DropDown
        id={id}
        isInvalid={isInvalid}
        isRequired
        label={label?.value}
        name="contactReason"
        onChange={onChange}
        options={options?.map(processOptions)}
        value={value}
      >
        {isInvalid && error?.value && (
          <ErrorMessage variant="error">
            <span data-property={error?.key}>{error?.value}</span>
          </ErrorMessage>
        )}
      </DropDown>
    </div>
  );
}

HelpReasonDropDown.propTypes = {
  id: PropTypes.string.isRequired,
  isInvalid: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  text: PropTypes.shape({
    label: PropTypes.shape({
      value: PropTypes.string.isRequired,
    }).isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.shape({
          value: PropTypes.string.isRequired,
        }).isRequired,
        optionValue: PropTypes.string.isRequired,
      }),
    ).isRequired,
    error: PropTypes.shape({
      value: PropTypes.string,
      key: PropTypes.string,
    }),
  }).isRequired,
  value: PropTypes.string,
};

HelpReasonDropDown.defaultProps = {
  isInvalid: false,
  value: '',
};
